import { editorConfig } from './editor/config/editorConfig';
// @ts-expect-error not typed
import { start } from 'ContentEditorUI/UniversalApplication';
start(editorConfig);